import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { getScope } from "lib/utils/getScopeLevel"

interface gameInitialState {
  auditLogsHeartbeatStarted: boolean
  auditLogsCompleteData: any
}

const initialState: gameInitialState = {
  auditLogsHeartbeatStarted: false,
  auditLogsCompleteData: {
    video_url: "video_na",
    widget_code: "matching_game",
    action_performed: null,
    payload: {
      seg_id: "segment_no",
      input_params_obj: {
        topic: "topic_na",
        scope: getScope() || "scope_na",
        difficulty_level: null,
        time_spent_sec: 0,
        question_count: null,
        consider_history: false,
        custom_instructions: null,
      },
      assessment_obj: {
        topic: "topic_na",
        scope: getScope() || "scope_na",
        pairs_total: 12,
        pairs_solved: 0,
        cards_viewed: 0,
        completion_percentage: 0,
        time_spent_seconds: 0,
      },
      blob_uri: {
        complete_blob_uri: [],
        generated_blob_uri: [],
        uploaded_blob_uri: [],
        downloaded_blob_uri: [],
      },
      compute_time: 0,
      tokens_used: 0,
      cache_hit: true,
      session_timeout: false,
      usage_time_in_sec: 0,
      watch_percentage: 0,
      video_duration: 0,
    },
  },
}

const GameSlice = createSlice({
  name: "matching-game",
  initialState,
  reducers: {
    setAuditLogsHeartbeatStarted: (state, action: PayloadAction<boolean>) => {
      state.auditLogsHeartbeatStarted = action.payload
    },
    setAuditLogsCompleteData: (state, action: PayloadAction<any>) => {
      state.auditLogsCompleteData = action.payload
    },
    resetState: () => initialState,
  },
})

export const { resetState, setAuditLogsHeartbeatStarted, setAuditLogsCompleteData } = GameSlice.actions

export default GameSlice.reducer
